import RECIST11 from '../guidelines/RECIST11';
import iRECIST from '../guidelines/iRECIST';
import RANOBM from '../guidelines/RANOBM';
import CUSTOM from '../guidelines/CUSTOM';
import RECIP10 from '../guidelines/RECIP10';

const guidelines = {
  RECIST11,
  iRECIST,
  RANOBM,
  CUSTOM,
  RECIP10,
};

export default guidelines;
